import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { patchCancelPayment } from '@/api/payment';
import {
  PostCancelPaymentBody,
  PostCancelPaymentResponse,
} from '@/types/payment.type';
import { useAppDispatch } from './useReduxHooks';
import { updateLoading } from '@/store/loading.store';

interface UsePostCancelPaymentProps {
  onSuccess?: (data: PostCancelPaymentResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const usePatchCancelPayment = ({
  onSuccess,
  onError,
}: UsePostCancelPaymentProps = {}) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isLoading, isError, error, isSuccess, data } =
    useMutation<PostCancelPaymentResponse, AxiosError, PostCancelPaymentBody>(
      (payload) => {
        dispatch(updateLoading({ isLoading: true }));
        return patchCancelPayment(payload);
      },
      {
        onSuccess: (data) => {
          // 결제 취소 후 결제 목록 캐시 무효화
          queryClient.invalidateQueries('paymentHistory');

          if (onSuccess) {
            onSuccess(data);
          }

          dispatch(updateLoading({ isLoading: false }));
        },
        onError: (error) => {
          console.error('Payment cancel error:', error);

          if (onError) {
            onError(error);
          }

          dispatch(updateLoading({ isLoading: false }));
        },
        retry: 0,
      },
    );

  return {
    cancelPayment: mutate,
    cancelPaymentAsync: mutateAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
  };
};
